import AddMedication from './AddMedication';

export default AddMedication;
